"use client";

import { useEffect } from "react";
import Script from "next/script";
import { GOOGLE_ADS, MICROSOFT_UET } from "@/lib/site";
import { captureAttribution } from "@/lib/attribution";

// Shared CodeFirst PostHog (EU), routed through this origin's /ingest proxy (handled
// by public/_worker.js) so ad/tracker blockers can't drop events. Autocapture gives
// pageviews + click events; signup_completed is emitted server-side from the worker.
// Google Ads gtag (conversion tracking for the Gate-1 campaigns) loads alongside.
const KEY = "phc_wet5bhEymPYyQy26QGPTdRUjyDuWm2UgWtpcQVbkweFF";

export function Analytics() {
  // Persist first-touch ad attribution as early as possible, before the visitor navigates
  // off the landing URL into the builder where ?msclkid=/?gclid= are gone. Runs in all envs
  // (it only touches localStorage); the tracking scripts below stay production-only.
  useEffect(() => {
    captureAttribution();
  }, []);

  if (process.env.NODE_ENV !== "production") return null;

  return (
    <>
    <Script src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS.id}`} strategy="lazyOnload" />
    <Script id="gtag" strategy="lazyOnload">
      {`window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', '${GOOGLE_ADS.id}');`}
    </Script>
    <Script id="uet" strategy="lazyOnload">
      {`(function(w,d,t,u,o){w[u]=w[u]||[],o.ts=(new Date).getTime();var n=d.createElement(t);n.src="https://bat.bing.net/bat.js?ti="+o.ti+("uetq"!=u?"&q="+u:""),n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&"loaded"!==s&&"complete"!==s||(o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad"),n.onload=n.onreadystatechange=null)};var i=d.getElementsByTagName(t)[0];i.parentNode.insertBefore(n,i)})(window,document,"script","uetq",{ti:"${MICROSOFT_UET.id}",enableAutoSpaTracking:true});`}
    </Script>
    <Script id="posthog" strategy="lazyOnload">
      {`!function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(o=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,o);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},n="init capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled onFeatureFlags getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures getActiveMatchingSurveys getSurveys getNextSurveyStep onSessionId".split(" "),r=0;r<n.length;r++)g(u,n[r]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
      posthog.init('${KEY}',{api_host:location.origin+'/ingest',ui_host:'https://eu.i.posthog.com',person_profiles:'always',capture_pageview:true,capture_pageleave:true,capture_exceptions:true});`}
    </Script>
    </>
  );
}
